"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.Link = styled_components_1.styled.a `
  color: ${({ theme }) => theme.link};
  flex: 1;
  margin-left: auto;
  cursor: pointer;
`;
//# sourceMappingURL=Link.js.map